<template>
    <div>
        <!--<div v-if="items.length === 0">
            Loading...
        </div>-->
        <!--<div v-else>-->
        <div>
            <add-trades ref='addTrades' v-bind:portfolioguid="portfolioGuid" v-bind:marketprop="marketId" v-bind:securityprop="security" @my-event="refreshTrades()"> </add-trades>
           <!-- <div v-for="(item) in unique(items, 'security')" :key="item.security">-->
            
            <div>
                <span>{{ securityItem.code }}</span> - <span class="text-muted">{{ securityItem.name }} </span>
                <br />
                <div class="d-flex flex-wrap align-items-center mb-2">
                    <div class="mr-4">
                        <span class="text-muted small">Last Price</span>
                        <div class="h4 mb-0">
                            {{ securityItem.lastPrice | currencyFormat }}
                            <i v-if="securityItem.marketId == 1" class="fa fa-refresh opaque cursor-pointer small" v-on:click="updatePrice(securityItem.marketId, securityItem.code)"></i>
                        </div>
                    </div>
                    <div class="mr-4">
                        <span class="text-muted small">52w High</span>
                        <div class="text-success">{{ securityItem.fiftyTwoWeekHigh | currencyFormat }}</div>
                    </div>
                    <div class="mr-4">
                        <span class="text-muted small">52w Low</span>
                        <div class="text-danger">{{ securityItem.fiftyTwoWeekLow | currencyFormat }}</div>
                    </div>
                    <!--<div v-if="securityItem.earningsDate">
                        <span class="text-muted small">Earnings Date</span>
                        <div>{{ formatDate(securityItem.earningsDate) }}</div>
                    </div>-->
                    <div>
                        <span class="text-muted small">PnL</span>
                        <div>{{ pnlItems && pnlItems.length ? pnlItems[0].profit : 0 | currency('$', 0) }}</div>
                    </div>
                </div>

                <div class="small opaque">
                    <span v-for="i in stockDaily" :key="i.key" class="badge badge-pill badge-dark" :title="i.date">
                        {{ i.openVariance / 100 | percent(1) }}
                    </span>
                </div>
                <div class="small opaque">
                    <span v-for="i in tradesPercs" :key="i.key" class="badge badge-pill badge-info" :title="i.closeDate">
                        {{ i.pctReturn / 100 | percent(1) }}
                    </span>
                </div>

                <!--<div v-if="positions.length > 0">
        <span class="text-muted small">Open positions</span>
        <table class="table table-sm table-dark table-striped table-bordered small">
            <thead>
                <tr>
                    <th scope="col">Trade Date </th>
                    <th scope="col">Price </th>
                    <th scope="col">Units </th>
                    <th class="d-none d-sm-table-cell" scope="col" @click="sort('units')">Brokerage </th>
                    <th scope="col">Total</th>
                    <th scope="col">PnL</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(trade, index) in positions" v-bind:class="{ 'd-none': index > 500 }" :key="index">
                    <td>{{ formatDate(trade.trade_Date) }}</td>
                    <td class="text-right">{{trade.average_Price | currencyFormat }}</td>
                    <td class="text-right">{{trade.units | numberFormat }}</td>
                    <td class="text-right d-none d-sm-table-cell">{{trade.brokerage_inc_GST | currency('$')}}</td>
                    <td class="text-right">{{trade.average_Price * trade.units | currency('$')}}</td>
                    <td :class="pnlClass(trade)">{{ (trade.lastPrice - trade.average_Price) * trade.units | currency('$')  }}</td>
                    <td :class="pnlClass(trade)">{{ (trade.lastPrice - trade.average_Price) / trade.average_Price | percent(1)  }}&nbsp;<span :class="taxClass(trade)"></span></td>
                    <td class="text-center"><a href="#" v-on:click="editPosition(trade)" class="fa fa-pencil-square-o"></a></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td class="text-right">{{ avg(positions, 'average_Price') | currencyFormat  }}</td>
                    <td class="text-right">{{ sum(positions, 'units') | numberFormat }}</td>
                    <td class="text-right d-none d-sm-table-cell">{{ sum(positions, 'brokerage_inc_GST') | currency('$') }}</td>
                    <td class="text-right">{{ avg(positions, 'average_Price') * sum(positions, 'units') | currency('$') }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>-->
                <div v-if="items.length > 0">
                    <span class="text-muted small">showing {{ (currentPage - 1) * pageSize + 1 }}-{{ Math.min(currentPage * pageSize, items.length) }} of {{items.length}} results...</span>
                    <table class="table table-sm table-dark table-striped table-bordered small">
                        <thead>
                            <tr>
                                <th scope="col" @click="sort('trade_Date')">Trade Date <i :class="sortClass('trade_Date')"></i></th>
                                <th scope="col" @click="sort('buy_Sell')">Buy/Sell <i :class="sortClass('buy_Sell')"></i></th>
                                <th scope="col" @click="sort('average_Price')">Price <i :class="sortClass('average_Price')"></i></th>
                                <th scope="col">PnL</th>
                                <th scope="col" @click="sort('units')">Units <i :class="sortClass('units')"></i></th>
                                <th class="d-none d-sm-table-cell" scope="col" @click="sort('units')">Brokerage <i :class="sortClass('brokerage_inc_GST')"></i></th>
                                <th scope="col">Total</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(trade, index) in sortedTrades" v-bind:class="{ 'd-none': index > 500 }" :key="index">
                                <td>{{ formatDate(trade.trade_Date) }}</td>
                                <td>{{ formatTradeType(trade.buy_Sell) }}</td>
                                <td>{{ trade.average_Price | currencyFormat }}</td>
                                <td :class="pnlClass(trade)"><template v-if="trade.isOpen">{{ (trade.lastPrice - trade.average_Price) / trade.average_Price | percent(1)  }}&nbsp;<span :class="taxClass(trade)"></span></template></td>
                                <td class="text-right">{{trade.units | numberFormat }}</td>
                                <td class="text-right d-none d-sm-table-cell">{{trade.brokerage_inc_GST | currency('$') }}</td>
                                <td class="text-right">{{ (trade.average_Price * trade.units) + trade.brokerage_inc_GST | currency('$') }}</td>
                                <td class="text-center"><a href="#" v-on:click="editTrade(trade)" class="fa fa-pencil-square-o"></a></td>
                            </tr>
                        </tbody>
                    </table>
                    <a class="btn btn-secondary" v-bind:class="{ 'disabled': currentPage === 1 }" href="#" @click.prevent="prevPage">
                        <i class="fa fa-arrow-circle-left"></i> Prev
                    </a>
                    &nbsp;
                    <a class="btn btn-secondary" v-bind:class="{ 'disabled': currentPage * pageSize >= items.length }" href="#" @click.prevent="nextPage">
                        Next <i class="fa fa-arrow-circle-right"></i>
                    </a>
                </div>
                <div v-if="filteredDividends(securityItem.code).length" class="mt-4">
                    <table class="table table-sm table-dark table-striped table-bordered small w-60 caption-top">
                        <caption class="text-white bg-secondary p-2">
                            Income&nbsp;<i v-if="securityItem.marketId == 1" class="fa fa-refresh opaque cursor-pointer" :class="{ 'text-warning': isUpdatingDividends }" v-on:click="updateDiv(securityItem.marketId, securityItem.code)"></i>
                        </caption>
                        <thead>
                            <tr>
                                <th scope="col">Ex Date</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Record Date</th>
                                <th scope="col">Payable Date</th>
                                <th scope="col">Franking Rate</th>
                                <th scope="col">Dividend</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dividend, index) in filteredDividends(securityItem.code)" :key="index">
                                <td>{{ formatDate(dividend.exDate) }}</td>
                                <td>{{ dividend.amount | currency('$') }}</td>
                                <td>{{ formatDate(dividend.recordDate) }}</td>
                                <td>{{ formatDate(dividend.payableDate) }}</td>
                                <td class="text-right">{{ dividend.frankingRate }}%</td>
                                <td class="text-right">{{ dividend.divAmount | currency('$') }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="5"></td>
                                <td class="text-right font-weight-bold">{{ sum(filteredDividends(securityItem.code), 'divAmount') | currency('$') }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>
<style scoped>
    table caption {
        caption-side: top;
    }
</style>
<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        props: {
            portfolioguid: String,
            securityprop: String,
            marketprop: Number
        },
        data: function () {
            return {
                modalTitle: "Add Trade",
                securities: [],
                tradeTypes: [{ text: 'Select One', value: null }, { text: 'Buy', value: 'B' }, { text: 'Sell', value: 'S' }],
                parentMessage: 'Parent',
                items: [],
                positions: [],
                dividends: [],
                pnlItems: [],
                portfolioGuid: this.portfolioguid,
                isIndividual: this.securityprop.length > 0,
                holding: {},
                security: this.securityprop,
                currentSort: 'trade_Date',
                currentSortDir: 'desc',
                pageSize: 15,
                currentPage: 1,
                marketId: this.marketprop,
                stockDaily: [],
                securityItem: {},
                tradesPercs: [],
                isUpdatingDividends: false

            }
        },
        async mounted() {

            this.getSecurity();
            this.getTrades();
            //this.getPositions();
            this.getDividends();
            this.getStockDailyVariance();
            this.getTradesPercentage();
            this.getPnl();
        },
        computed: {
            sortedTrades: function () {
                return this.items.slice().sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                }).filter((row, index) => {
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
            }
        },
        methods: {
            async updatePrice(marketId, code) {
                console.log(code);

                await axios.get('/api/securities/UpdateLastPrice', {
                    params: {
                        marketId: marketId,
                        code: code
                    }
                });

                this.refreshTrades();
            },
            async updateDiv(marketId, code) {
                console.log(code);
                this.isUpdatingDividends = true;

                await axios.get('/dividends/UpdateDividend', {
                    params: {
                        marketId: marketId,
                        code: code
                    }
                });

                await this.getDividends();
                this.isUpdatingDividends = false;
            },
            editTrade(trade) {
                console.log(trade);

                this.$refs.addTrades.editTrade(trade);                
            },
            editPosition(pos) {             
                console.log(pos);

                this.$refs.addTrades.editTrade(pos);
            },
            nextPage: function () {
                if ((this.currentPage * this.pageSize) < this.items.length) this.currentPage++;
            },
            prevPage: function () {
                if (this.currentPage > 1) this.currentPage--;
            },
            sortClass: function (s) {
                if (this.currentSort == s) {
                    if (this.currentSortDir == 'desc') return "fa fa-sort-desc fa-fw cursor-pointer"
                    return "fa fa-sort-asc fa-fw cursor-pointer"
                }

                return "fa fa-sort fa-fw text-muted cursor-pointer";

            },
            pnlClass: function (trade) {
                return trade.lastPrice - trade.average_Price < 0 ? "text-right text-danger" : "text-right text-success";
            },
            taxClass: function (trade) {               
                var date = moment().add(-1, 'y').toDate();
                if (moment(trade.trade_Date).isBefore(date)) {
                    return "fa fa-diamond";
                } else return "";
            },
            sort: function (s) {
                //if s == current sort, reverse
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
                }
                this.currentSort = s;
            },
            editDividend: function (div) {
                //var self = this;
                console.log(div);

                var divEdit = { portfolioId: div.portfolioId, SecurityDividendId: div.securityDividendsId, isReceived: div.isReceived };

                console.log(divEdit);

                axios.post('/api/trades/editdividend', divEdit)
                    .then(function () {

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getData(obj) {
                console.log(obj);
            },
            getSecurities: function (security) {
                return this.items.find(a => a.security === security)
            },
            filteredMarkets(marketId) {
                return this.items.filter(item => item.marketId === marketId);
            },
            filteredItems(security) {
                return this.items.filter(item => item.security === security);
            },
            filteredDividends(security) {
                return this.dividends.filter(item => item.code === security);
            },
            async refreshTrades() {
                this.getSecurity();
                await this.getTrades();
                //this.getPositions();
            },
            async getStockDailyVariance() {

                const { data } = await axios.get('/analysis/GetStockDailyVariance', {
                    params: {                        
                        marketId: this.marketId,
                        code: this.security                        
                    }
                });

                this.stockDaily = data;
            },
            async getTradesPercentage() {

                const { data } = await axios.get('/api/trades/GetTradePercentages', {
                    params: {
                        portfolioId: 2,
                        code: this.security
                    }
                });

                this.tradesPercs = data;
            },
            async getTrades() {
                console.log("getTrades");

                const { data } = await axios.get('/api/trades/GetTradesByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: this.security,
                        marketId: this.marketId,
                        includeOpen: true
                    }
                });

                this.items = data;
            },
            async getPnl() {

                const { data } = await axios.get('/api/trades/GetPnLByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: this.security,
                        resultsInPortfolioCurrency: false
                    }
                });

                this.pnlItems = data;

            },
            async getSecurity() {

                const { data } = await axios.get('/api/securities/GetSecurity', {
                    params: {                        
                        marketId: this.marketId,
                        code: this.security
                    }
                });

                this.securityItem = data;
            },
            //async getPositions() {

            //    const { data } = await axios.get('/api/trades/GetPositionsByPortfolio', {
            //        params: {
            //            portfolioGuid: this.portfolioGuid,
            //            security: this.security,
            //            marketId: this.marketId
            //        }
            //    });

            //    this.positions = data;
            //},
            async getDividends() {

                const { data } = await axios.get('/api/trades/GetDividendsByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid,
                        security: this.security
                    }
                });

                this.dividends = data;
            }
        }
    }
</script>
